import ScrollReveal from '@/components/ui/ScrollReveal'
import Tag from '@/components/ui/Tag'

interface ProjectTechStackProps {
  techStack: string[]
  sectionNumber?: string
}

export default function ProjectTechStack({ techStack, sectionNumber }: ProjectTechStackProps) {
  return (
    <ScrollReveal>
      <div className="grid grid-cols-1 md:grid-cols-[200px_1fr] gap-8 md:gap-12">
        <div>
          {sectionNumber && (
            <span className="text-label text-accent block mb-1">{sectionNumber}</span>
          )}
          <span className="text-label uppercase tracking-widest text-text-muted">
            Tools & Tech
          </span>
        </div>
        <div className="flex flex-wrap gap-2">
          {techStack.map((tool) => (
            <Tag key={tool} label={tool} />
          ))}
        </div>
      </div>
    </ScrollReveal>
  )
}
